<template>
  <div style='overflow:visible'>
    <!--
    <div class="bg-white max-w-sm rounded overflow-hidden shadow-lg flex" style='overflow:visible'>
    -->
      <multiselect v-model='event' class="my-auto" :options='events' :multiple='true' :taggable='true' @tag="addTag" placeholder='Select event(s)'/>
      <!--
    </div>
      -->
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
  props:{
    eventsList:{
      type:Array,
      required:true
    },
    value:{
      type:String,
      required:true
    }
  },
  components:{
    Multiselect
  },
  data() {
    const events = this.eventsList.map( (e) => {
      return e;
    });
    return {
      event:(this.value||'').split(",").filter( (e) => {
        return e !== ""
      }),
      events
    }
  },
  methods:{
    addTag(tag) {
      this.events.push(tag);
      this.event.push(tag);
    }
  },
  watch:{
    event() {
      this.$emit("input", this.event.join(","));
    }
  }
}
</script>
